import { render, staticRenderFns } from "./FingerprintAuthorisation.vue?vue&type=template&id=768ed5b4&"
import script from "./FingerprintAuthorisation.vue?vue&type=script&lang=js&"
export * from "./FingerprintAuthorisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports